<template>
  <div class="credit-book-form-container">
    <v-form ref="creditBookForm" class="pa-2">
      <!-- Section: General Information -->
      <div class="form-header mb-6">
        <span class="text-h6 font-weight-bold ">Configuración CreditBook</span>
        <p class="text-subtitle-2 grey--text mt-1 mb-n4">Configure los detalles generales y beneficiarios del
          CreditBook.</p>
      </div>

      <v-row dense>
        <v-col cols="12" md="12">
          <v-card flat outlined class="rounded-lg pa-4 mb-4">
            <div class="d-flex align-center mb-4">
              <v-icon small class="mr-2">mdi-information-outline</v-icon>
              <span class="text-overline font-weight-bold">Información General</span>
            </div>

            <v-text-field v-model="data.nom" :rules="rules.requerido" label="Nombre del CreditBook"
              placeholder="Ej. Paquete Corporativo A" prepend-inner-icon="mdi-label-outline" outlined dense class="mb-2"
              required></v-text-field>

            <v-text-field v-model="data.cnt" :rules="rules.requeridoNumero" type="number" label="Cantidad / Crédito ($)"
              placeholder="0.00" prepend-inner-icon="mdi-currency-usd" outlined dense required></v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
            <v-tab>
              Beneficios
            </v-tab>
            <v-tab>
              Creditos aplicables en:
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat outlined class="rounded-lg pa-4 fill-height">
                <div class="d-flex align-center mb-4">
                  <v-icon small class="mr-2">mdi-account-group-outline</v-icon>
                  <span class="text-overline font-weight-bold">Beneficiarios</span>
                </div>

                <div class="d-flex align-center gap-2 mb-4">
                  <v-autocomplete v-model="auxClienteId" label="Buscar cliente..." :items="clientes" item-text="text"
                    item-value="id" hide-details outlined dense prepend-inner-icon="mdi-magnify" class="flex-grow-1"
                    @keyup.enter="addCliente"></v-autocomplete>
                  <v-btn @click="addCliente" color="primary" depressed height="40" class="ml-2"
                    :disabled="!auxClienteId">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>

                <div class="beneficiaries-list-container">
                  <v-fade-transition group hide-on-leave>
                    <div v-for="(clienteId, index) in data.bnf" :key="clienteId"
                      class="beneficiary-item pa-2 mb-2 rounded border d-flex align-center">
                      <v-avatar size="32" color="primary lighten-4" class="mr-3">
                        <span class="primary--text font-weight-bold text-caption">
                          {{ getClienteInitials(clienteId) }}
                        </span>
                      </v-avatar>
                      <div class="flex-grow-1 text-truncate">
                        <span class="text-body-2 font-weight-medium">{{ getClienteName(clienteId) }}</span>
                      </div>
                      <v-btn icon small color="error" @click="deleteCliente(index)" class="ml-2">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </v-fade-transition>

                  <div v-if="data.bnf.length === 0" class="empty-state pa-8 text-center grey--text lighten-1">
                    <v-icon large color="grey lighten-2">mdi-account-off-outline</v-icon>
                    <p class="text-caption mt-2">No hay beneficiarios agregados</p>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat outlined class="rounded-lg pa-4 mb-4">
                <div class="d-flex align-center mb-4">
                  <v-icon small class="mr-2">mdi-information-outline</v-icon>
                  <span class="text-overline font-weight-bold">Creditos aplicables en:</span>
                </div>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-select v-model="auxForm.tipoFiltro" :items="tiposFiltro" label="Tipo de beneficio" outlined dense
                      class="mb-2" required></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-autocomplete v-if="auxForm.tipoFiltro != 'T'" v-model="auxForm.filtro" :items="dataItems"
                      label="Beneficio" outlined dense class="mb-2" required></v-autocomplete>
                    <v-text-field v-else v-model="auxForm.filtro" label="Tag" outlined dense class="mb-2"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model="auxForm.pu.C" :rules="rules.requeridoNumero" type="number"
                      label="Precio Unitario" placeholder="0.00" prepend-inner-icon="mdi-currency-usd" outlined dense
                      required></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-btn @click="addBenefit" color="primary" depressed height="40" class="ml-2"
                      :disabled="!auxForm.filtro">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>

                </v-row>
                <div class="beneficiaries-list-container">
                  <v-fade-transition group hide-on-leave>
                    <div v-for="(pr, index) in data.prs" :key="index"
                      class="beneficiary-item pa-2 mb-2 rounded border d-flex align-center">
                      <v-avatar size="32" color="primary lighten-4" class="mr-3">
                        <span class="primary--text font-weight-bold text-caption">
                          {{ pr.tp }}
                        </span>
                      </v-avatar>
                      <div class="flex-grow-1 text-truncate">
                        <span class="text-body-2 font-weight-medium">{{ getTipoFiltroName(pr.tp) }}: {{ (pr.tp == "P") ?
                          getProductName(pr.fl) : (pr.tp == "C") ? getCategoryName(pr.fl) : pr.fl }}</span>
                      </div>
                      <v-btn icon small color="error" @click="deleteCliente(index)" class="ml-2">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </v-fade-transition>

                  <div v-if="data.bnf.length === 0" class="empty-state pa-8 text-center grey--text lighten-1">
                    <v-icon large color="grey lighten-2">mdi-package</v-icon>
                    <p class="text-caption mt-2">No hay elementos agregados</p>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>


      <div class="d-flex justify-end gap-3 actions-footer">
        <v-btn text large class="px-8 rounded-lg" @click="$emit('toggle', false)">
          Cancelar
        </v-btn>
        <v-btn color="primary" large depressed class="px-8 rounded-lg shadow-sm" @click="checkForm">
          <v-icon left>mdi-check</v-icon>
          Guardar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import CreditBook from "../../../clases/CreditBooks/CreditBook.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CreditBookForm",
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    dataEdit: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      Categories: [],
      auxClienteId: "",
      data: CreditBook.getPropertyModel(),
      tab: 0,
      auxForm: {
        tipoFiltro: "",
        filtro: "",
        pu: { C: 0, M: "MXN" }
      },
      tiposFiltro: [
        {
          text: "Producto",
          value: "P"
        },
        {
          text: "Categoría",
          value: "C"
        },
        {
          text: "Tag",
          value: "T"
        }
      ],
      rules: {
        requerido: [(value) => !!value || "El campo es requerido"],
        requeridoNumero: [(value) => Number(value) >= 0 || "El valor debe ser positivo"],
      },
    };
  },
  computed: {
    clientes() {
      let clientes = [];
      let rowclientes = this.$store.getters.getClientes || [];
      rowclientes.forEach((element) => {
        if (element.id !== "PUBLICOGENERAL") {
          clientes.push({
            ...element,
            value: element.id,
            text: `${element.Apellidos || ""} ${element.Nombres || ""}${element.Apodo ? ` (${element.Apodo})` : ""}`
          });
        }
      });
      return clientes;
    },
    dataItems() {
      let productos = [];
      let rowproductos = this.$store.getters.getProductos || [];
      if (this.auxForm.tipoFiltro == "P") {
        rowproductos.forEach((element) => {
          if (element.Dlat == null) {
            productos.push({
              ...element,
              value: element.id,
              text: element.Nombre + " - " + element.Tipo
            });
          }
        });
      }
      if (this.auxForm.tipoFiltro == "C") {
        this.Categories.forEach((categories) => {
          productos.push({
            ...categories,
            value: categories.id,
            text: categories.Nombre
          });
        });
      }
      return productos;
    },
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    getTipoFiltroName(tipoFiltro) {
      const tipo = this.tiposFiltro.find(x => x.value == tipoFiltro);
      return tipo ? tipo.text : "";
    },
    getProductName(id) {
      const producto = this.$store.getters.getProductos.find(x => x.id == id);
      return producto ? producto.Nombre : "";
    },
    getCategoryName(id) {
      const category = this.Categories.find(x => x.id == id);
      return category ? category.Nombre : "";
    },
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    getClienteName(id) {
      const cliente = this.clientes.find(c => c.id === id);
      return cliente ? cliente.text : "Cliente Desconocido";
    },
    getClienteInitials(id) {
      const cliente = this.clientes.find(c => c.id === id);
      if (!cliente) return "??";
      const names = (cliente.Nombres || "").split(" ");
      const lastNames = (cliente.Apellidos || "").split(" ");
      return ((names[0] ? names[0][0] : "") + (lastNames[0] ? lastNames[0][0] : "")).toUpperCase();
    },
    addBenefit() {
      if (!this.auxForm.filtro) {
        this.$swal({
          title: "Atención",
          text: "Debe seleccionar un beneficio antes de agregar.",
          icon: "info",
          timer: 2000,
          showConfirmButton: false
        });
        return;
      }

      const exists = this.data.prs.find(x => x.fl == this.auxForm.filtro);
      if (!exists) {
        this.auxForm.pu.C = Number(this.auxForm.pu.C);
        this.data.prs.push({
          tp: this.auxForm.tipoFiltro,
          fl: this.auxForm.filtro,
          pu: this.auxForm.pu
        });
        this.auxForm.filtro = "";
      } else {
        this.$swal({
          title: "Atención",
          text: "El beneficio ya se encuentra en la lista.",
          icon: "warning",
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    addCliente() {
      if (!this.auxClienteId) {
        this.$swal({
          title: "Atención",
          text: "Debe seleccionar un cliente antes de agregar.",
          icon: "info",
          timer: 2000,
          showConfirmButton: false
        });
        return;
      }

      const exists = this.data.bnf.includes(this.auxClienteId);
      if (!exists) {
        this.data.bnf.push(this.auxClienteId);
        this.auxClienteId = "";
      } else {
        this.$swal({
          title: "Atención",
          text: "El cliente ya se encuentra en la lista de beneficiarios.",
          icon: "warning",
          timer: 2500,
          showConfirmButton: false
        });
      }
    },
    deleteCliente(index) {
      this.data.bnf.splice(index, 1);
    },
    checkForm() {
      if (this.$refs.creditBookForm.validate()) {
        const action = this.edit ? "EDIT" : "CREATE";
        this.send(action);
      }
    },
    send(action) {
      const dataSave = { ...this.data };
      dataSave.cnt = Number(dataSave.cnt);
      dataSave.Tenant = this.$store.getters.getFirebaseApp.tenant;

      if (action === "EDIT") {
        dataSave.Id = this.dataEdit.id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    this.getCategories();
    if (this.edit && this.dataEdit) {
      const cbmodel = new CreditBook(this.dataEdit);
      this.data = { ...cbmodel.properties };
    }
  },
};
</script>

<style scoped>
.credit-book-form-container {
  max-width: 900px;
  margin: 0 auto;
}

.beneficiaries-list-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px;
  background-color: #fafafa;
}

.beneficiary-item {
  background-color: white;
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0;
}

.beneficiary-item:hover {
  background-color: #f5f5f5;
  border-color: #bdbdbd;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}



/* Custom Scrollbar */
.beneficiaries-list-container::-webkit-scrollbar {
  width: 6px;
}

.beneficiaries-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.beneficiaries-list-container::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 10px;
}

.beneficiaries-list-container::-webkit-scrollbar-thumb:hover {
  background: #bdbdbd;
}
</style>
